import http from '../http-common'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { CampaignCreate } from '@types'

const responseBody = (response: AxiosResponse) => response.data

const requests = {
	get: (url: string, config?: AxiosRequestConfig) => http.get(url, config).then(responseBody),
	post: (url: string, config: AxiosRequestConfig) =>
		http
			.post(url, config)
			.then(responseBody)
			.catch((error) => {
				return Promise.reject(error)
			}),
	delete: (url: string) => http.delete(url).then(responseBody)
}

export const campaignService = {
	createCampaign: (config: AxiosRequestConfig): Promise<CampaignCreate> =>
		requests.post('campaigns/create-campaign', config.data).catch((error) => Promise.reject(error))
}
